/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class QueueScheduleRowComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCategoryTag: false
        };

        this.toggleCategoryTag = this.toggleCategoryTag.bind(this);

    }

    toggleCategoryTag() {
        let showCategoryTag = (this.state.showCategoryTag) ? false : true;

        this.setState({
            showCategoryTag: showCategoryTag
        });

    }

    render() {

        let date = moment(),
            isoDate = null,
            time = [],
            startTime = '',
            formattedTime = null,
            constants = this.props.app.config.constants,
            days = [
                constants.FS_SUNDAY,
                constants.FS_MONDAY,
                constants.FS_TUESDAY,
                constants.FS_WEDNESDAY,
                constants.FS_THURSDAY,
                constants.FS_FRIDAY,
                constants.FS_SATURDAY,
            ],
            categoryHint = null,
            categoryTag = null,
            editor = null,
            rowToggleIcon = (
                <i className="icon ion-chevron-right"></i>
            );

        if (this.props.schedule.s_startTime) {

            startTime = this.props.schedule.s_startTime;

            time = startTime.split(':');

            date.set({hour: time[0], minute: time[1], second: time[2]});

            isoDate = date.toISOString();
            formattedTime = date.format('h:mm A');

        }

        if (this.props.schedule.s_tagID) {
            let category = null;
            for (let i = 0; i < this.props.categoryList.length; ++i) {
                if (this.props.categoryList[i].id == this.props.schedule.s_tagID) {
                    category = this.props.categoryList[i];
                }
            }
            if (category && category !== null) {
                if (this.state.showCategoryTag) {
                    let textColor = '',
                        hex = category.color.replace("#", ""),
                        r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // stolen from stackoverflow...
                    textColor = ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? '#000000' : '#FFFFFF';

                    categoryTag = (
                        <div className="category-tag" style={{"border": '1px solid ' + category.color, 'backgroundColor': category.color, 'color': textColor}}>
                            {category.name}
                        </div>
                    );
                }
                categoryHint = (
                    <td className="category-hint" style={{'backgroundColor': category.color}} onMouseEnter={this.toggleCategoryTag} onMouseLeave={this.toggleCategoryTag}>
                        {categoryTag}
                    </td>
                );
            }

        }

        if (this.props.editingSchedule === this.props.schedule.s_id) {
            rowToggleIcon = (<i className="icon ion-chevron-down"></i>)
        }

        return (
            <tr>
                <td className="queue-toggle-cell">
                    <div className="queue-row-toggle" onClick={this.props.toggleHandler} data-scheduleid={this.props.schedule.s_id} role="button" aria-label="toggle row">
                        {rowToggleIcon}
                    </div>
                </td>
                {days.map((day, i) => {
                    let active = (parseInt(this.props.schedule.s_days, 10) & parseInt(day, 10)),
                        cellClass = (active) ? 'cell-schedule cell-active' : 'cell-schedule cell-inactive',
                        label = (active) ? formattedTime : '+';

                    return (
                        <td key={this.props.schedule.s_id + ":" + day} className={cellClass} data-active={active} data-daybit={day} data-sid={this.props.schedule.s_id} onClick={this.props.clickHandler} role="button" aria-label="toggle time">
                            {label}
                        </td>
                    );
                })}
                <td className="queue-remove-schedule">
                    <i className="fa fa-times-circle" data-delete={true} data-sid={this.props.schedule.s_id} onClick={this.props.clickHandler} role="button" aria-label="remove time"></i>
                </td>
                {categoryHint}
            </tr>
        );

    }

};

QueueScheduleRowComponent.displayName = "QueueScheduleRowComponent";

QueueScheduleRowComponent.propTypes = {
    schedule: PropTypes.object,
    clickHandler: PropTypes.func,
    changeHandler: PropTypes.func
};

QueueScheduleRowComponent.defaultProps = {
    schedule: {},
    clickHandler: null,
    changeHandler: null
};

export default QueueScheduleRowComponent;
